import React from 'react';
import { Button, Checkbox, Popover, Whisper } from 'rsuite';
import { ColumnDef } from './useTableColumns';

type ColumnsButtonProps = {
  /** Column config from useTableColumns (display flag drives the checkbox). */
  columns: ColumnDef[];
  /** Toggle handler — pass the `toggleColumn` returned by useTableColumns. */
  onToggle: (value: string) => void;
};

/**
 * Toolbar "Колонки" control: a button that opens a popover with one
 * checkbox per column (checked = visible). The last visible column cannot
 * be unchecked so the table never renders empty.
 *
 * @param props
 */
export default function ColumnsButton({
  columns,
  onToggle,
}: ColumnsButtonProps) {
  const visibleCount = columns.filter(
    column => column.display !== false
  ).length;

  return (
    <Whisper
      placement="bottomEnd"
      trigger="click"
      speaker={
        <Popover className="columns-popover" arrow={false}>
          <div className="columns-popover__header">Показати колонки</div>
          <div className="columns-popover__list">
            {columns.map(column => {
              const checked = column.display !== false;
              return (
                <Checkbox
                  key={column.value}
                  checked={checked}
                  disabled={checked && visibleCount === 1}
                  onChange={() => onToggle(column.value)}
                >
                  {column.label}
                </Checkbox>
              );
            })}
          </div>
        </Popover>
      }
    >
      <Button appearance="ghost">Колонки</Button>
    </Whisper>
  );
}
